import React from 'react';
import '../styles/TermsOfService.css';
import { Helmet } from 'react-helmet';

function TermsOfService() {
    return (
        <div className="terms-container">
            <Helmet>
                <meta charSet="utf-8" />
                <title>Terms Of Service</title>
                <link rel="canonical" href="https://ehchadservices.com/TermsOfService" />
            </Helmet>
            <h2>Terms of Service</h2>
            <p>Welcome to ehchadservices.com. These Terms of Service ("Terms") govern your access to and use of our website and services. By accessing or using ehchadservices.com, you agree to be bound by these Terms. If you disagree with any part of the Terms, then you may not access the website.</p>

            <h3>1. Acceptance of Terms</h3>
            <p>By accessing this website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. If you do not agree to these Terms, please do not use this website.</p>

            <h3>2. Description of Services</h3>
            <p>ehchadservices.com provides software and programs for gamers and content creators, etc. We reserve the right to modify or discontinue any of our services at any time without prior notice.</p>

            <h3>3. User Responsibilities</h3>
            <p>You are responsible for your use of the website and for any content you post. You agree to use the website in a manner consistent with all applicable laws and regulations.</p>

            {/* Add more sections as needed */}

            <h3>4. Intellectual Property</h3>
            <p>The content on ehchadservices.com, including text, graphics, logos, images, and software, is the property of ehchadservices.com and is protected by copyright and other intellectual property laws.</p>

            <h3>5. Disclaimer</h3>
            <p>ehchadservices.com is provided "as is" without any warranties, express or implied. We do not warrant that the website will be uninterrupted or error-free.</p>

            <h3>6. Limitation of Liability</h3>
            <p>In no event shall ehchadservices.com be liable for any damages arising out of or in connection with your use of the website.</p>

            <h3>7. Governing Law</h3>
            <p>These Terms shall be governed by and construed in accordance with the laws of Michigan.</p>

            <h3>8. Changes to Terms</h3>
            <p>We may update these Terms from time to time. We will post any changes on this page. Your continued use of the website following the posting of revised Terms means that you accept and agree to the changes.</p>

            <h3>9. Contact Us</h3>
            <p>If you have any questions about these Terms, please contact us at ehchadservices@gmail.com.</p>
        </div>
    );
}

export default TermsOfService;